import { createContext, useContext } from 'react'
import useTrading from './hooks/useTrading'

const TradingContext = createContext(null)

export function TradingProvider({
  children,
  publicKey, signTransaction,
  currentToken,
  defaults, showToast,
  solPriceRef, lastBucketMcapRef, tokenSupplyRef, rawTradesRef,
  dataSource, wsRef, hlPair,
}) {
  const trading = useTrading({
    publicKey, signTransaction,
    currentToken,
    defaults, showToast,
    solPriceRef, lastBucketMcapRef, tokenSupplyRef, rawTradesRef,
    dataSource, wsRef, hlPair,
  })

  return (
    <TradingContext.Provider value={trading}>
      {children}
    </TradingContext.Provider>
  )
}

export function useTradingContext() {
  const ctx = useContext(TradingContext)
  if (!ctx) throw new Error('useTradingContext must be used within TradingProvider')
  return ctx
}
